import AgentInterface from './AgentInterface';
import { BsDatabaseCheck } from 'react-icons/bs';

/**
 * Implementación del Agente de Lineamientos de Base de Datos que se comunica con n8n
 */
class LineamientosAgent extends AgentInterface {
  constructor(config = {}) {
    super({
      name: 'Agente de Lineamientos de Base de Datos',
      description: 'Agente experto en los lineamientos de Bases de Datos de Sistran.',
      icon: BsDatabaseCheck,
      webhookEndpoint: '/webhook/inputLDb',
      ...config,
    });

    if (!config.n8nService) {
      throw new Error('n8nService es requerido para LineamientosAgent');
    }
    this.n8nService = config.n8nService;
  }

  /**
   * Envía un mensaje al webhook de n8n y devuelve la respuesta
   * @param {string} message - Mensaje del usuario
   * @param {Object} context - Contexto adicional (historial, etc.)
   * @returns {Promise<Object>} Respuesta del agente
   */
  async sendMessage(message, context = {}) {
    try {
      const response = await this.n8nService.sendToWebhook(
        this.config.webhookEndpoint,
        {
          message,
          context: {
            userId: context.userId,
            sessionId: context.sessionId,
            // Agregar más contexto según sea necesario
          },
        }
      );

      return {
        success: true,
        response: response.message || 'No se recibió respuesta del asistente',
        metadata: response.metadata || {},
      };
    } catch (error) {
      console.error('Error en LineamientosAgent:', error);
      return {
        success: false,
        error: 'No se pudo conectar con el asistente. Por favor, inténtalo de nuevo más tarde.',
        originalError: error.message,
      };
    }
  }
}

export default LineamientosAgent;
